export const GiftPreview = ({ buyer, recipient, note }) => (
  <div className="rounded-2xl bg-[#f6f3ec] p-5 text-[#1f1a12] shadow-[0_20px_60px_rgba(0,0,0,0.35)]" data-testid="gift-email-preview">
    <p className="font-code text-[10px] uppercase tracking-[0.25em] text-[#8a8170] mb-3">Email preview</p>
    <div className="rounded-xl bg-white border border-[#e8e1d2] p-6 space-y-4">
      <p className="font-display text-lg">Lore<span className="text-amber-600">ly</span></p>
      <h3 className="font-display text-2xl leading-snug">A year of unlimited worlds, for you</h3>
      <p className="text-sm text-[#3d362a]">Hi {recipient || "there"},</p>
      <p className="text-sm text-[#3d362a]"><strong>{buyer}</strong> has given you a full year of Lorely Pro: unlimited worlds for your stories, wikis, timelines and family trees.</p>
      {note.trim() && (
        <div className="border-l-[3px] border-amber-500 bg-[#fbf7ee] rounded-md px-4 py-3 font-display italic text-[#3d362a] whitespace-pre-wrap break-words" data-testid="gift-preview-note">
          {note}
          <span className="block not-italic text-xs text-[#8a8170] mt-1">— {buyer}</span>
        </div>
      )}
      <span className="inline-block rounded-full bg-amber-500 px-5 py-2.5 text-sm font-semibold text-onaccent">Redeem your year of Pro</span>
    </div>
  </div>
);
